import React from 'react';
import { GmailIcon, WhatsAppIcon } from './ContactIcons';
import { routeHref, routes } from '../data/siteData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-accent/10 bg-white">
      <div className="container-custom py-12 sm:py-16">
        <div className="grid items-start gap-10 lg:grid-cols-[1.2fr_1fr_0.9fr] lg:gap-12">
          <div>
            <div className="mb-5 flex items-center gap-3">
              <img className="site-logo" src="/media/logo.svg" alt="S4CoconutExports logo" />
              <p className="text-lg font-serif font-bold text-secondary sm:text-xl">S4CoconutExports</p>
            </div>
            <p className="max-w-md text-sm leading-7 text-muted">
              Global coconut export partner for importers, wholesalers, distributors, food industries, and retail supply chains.
            </p>
          </div>

          <div>
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.28em] text-accent">Quick links</p>
            <div className="grid grid-cols-2 gap-3">
              {routes.map((route) => (
                <a key={route.path} href={routeHref(route.path)} className="text-sm text-muted hover:text-accent">
                  {route.label}
                </a>
              ))}
            </div>
          </div>

          <div className="footer-inquiry">
            <p className="mb-4 text-xs font-semibold uppercase tracking-[0.28em] text-accent">Inquiry</p>
            <p className="mb-5 text-sm leading-7 text-muted">
              Email s4cocoexports@gmail.com or WhatsApp +91 6383860220 for export inquiries.
            </p>
            <div className="footer-contact-actions">
              <a href="mailto:s4cocoexports@gmail.com" aria-label="Email S4CoconutExports">
                <GmailIcon className="footer-contact-icon" />
                Gmail
              </a>
              <a href="https://wa.me/916383860220" target="_blank" rel="noreferrer" aria-label="WhatsApp S4CoconutExports">
                <WhatsAppIcon className="footer-contact-icon" />
                WhatsApp
              </a>
            </div>
            <a className="btn-primary mt-5" href={routeHref('/contact')}>Start Inquiry</a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-accent/10 pt-8 text-center text-sm text-muted sm:mt-14 md:flex-row md:text-left">
          <p>&copy; {currentYear} S4CoconutExports. All rights reserved.</p>
          <p>B2B Coconut Export Company</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
